import {
  getObjects,
  getObjectsWithParams,
  getObject,
  addObject,
  updateObject,
  deleteObject,
} from "./Api";

// Medical Equipment API
export const listMedicalEquipment = (params, token) => {
  return getObjectsWithParams("medical-equipment", params, token);
};

export const getMedicalEquipment = (id, token) => {
  return getObject("medical-equipment", id, token);
};

export const createMedicalEquipment = (data, token) => {
  return addObject("medical-equipment", data, token);
};

export const updateMedicalEquipment = (id, data, token) => {
  return updateObject("medical-equipment", data, id, token);
};

export const deleteMedicalEquipment = (id, token) => {
  return deleteObject("medical-equipment", id, token);
};

export const getAvailableEquipment = (token) => {
  return getObjects("medical-equipment/available", token);
};

export const getInUseEquipment = (token) => {
  return getObjects("medical-equipment/in_use", token);
};

export const assignEquipmentToPatient = (equipmentId, data, token) => {
  return addObject(
    `medical-equipment/${equipmentId}/assign_to_patient`,
    data,
    token
  );
};

// Patient Equipment Assignment API
export const listPatientEquipmentAssignments = (params, token) => {
  return getObjectsWithParams("patient-equipment-assignments", params, token);
};

export const getPatientEquipmentAssignment = (id, token) => {
  return getObject("patient-equipment-assignments", id, token);
};

export const createPatientEquipmentAssignment = (data, token) => {
  return addObject("patient-equipment-assignments", data, token);
};

export const updatePatientEquipmentAssignment = (id, data, token) => {
  return updateObject("patient-equipment-assignments", data, id, token);
};

export const deletePatientEquipmentAssignment = (id, token) => {
  return deleteObject("patient-equipment-assignments", id, token);
};

export const endEquipmentAssignment = (id, endTime, token) => {
  return addObject(
    `patient-equipment-assignments/${id}/end_assignment`,
    { end_time: endTime },
    token
  );
};

export const calculateAssignmentCharges = (id, token) => {
  return getObject(
    `patient-equipment-assignments/${id}/calculate_charges`,
    "",
    token
  );
};

export const getActiveAssignments = (token) => {
  return getObjects("patient-equipment-assignments/active_assignments", token);
};

export const getAdmissionEquipmentAssignments = (admissionId, token) => {
  return getObjectsWithParams(
    "patient-equipment-assignments",
    { admission: admissionId },
    token
  );
};

// Equipment Charges API
export const listEquipmentCharges = (params, token) => {
  return getObjectsWithParams("equipment-charges", params, token);
};

export const getEquipmentCharge = (id, token) => {
  return getObject("equipment-charges", id, token);
};

export const createEquipmentCharge = (data, token) => {
  return addObject("equipment-charges", data, token);
};

export const updateEquipmentCharge = (id, data, token) => {
  return updateObject("equipment-charges", data, id, token);
};

export const deleteEquipmentCharge = (id, token) => {
  return deleteObject("equipment-charges", id, token);
};

export const markChargePaid = (id, token) => {
  return addObject(`equipment-charges/${id}/mark_paid`, {}, token);
};

export const getChargeSummary = (token) => {
  return getObjects("equipment-charges/summary", token);
};
